import { SearchBarSVG } from 'assets/svg/HomePageSVG/SearchBarSVG'
import { Button, Form } from 'react-bootstrap'

function SearchBar(props) {
	return (
		<Form>
			<Form.Group controlId="formBasicEmail">
				<Form.Control {...props} />
			</Form.Group>
			<Button variant="dark">
				<SearchBarSVG width="24" height="24" viewBox="0 0 24 24" />
			</Button>
		</Form>
	)
}

export default SearchBar
